<template>
  <div>
    <h1>Expenses</h1>
    <v-list dense>
      <v-subheader>Gastos</v-subheader>
      <v-list-item-group>
        <v-list-item v-for="(item, i) in items" :key="i" @click="onItemClick(i)">
          <v-list-item-icon>
            <v-icon>{{ getIcon(item) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.amount }} {{ item.currency }} </v-list-item-title>
            <v-list-item-subtitle> {{ item.description ? item.description : 'no description' }} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <div v-if="false" style="font-family: monospace; font-size: 70%">
      {{ selectedItem }}
    </div>

    <v-bottom-sheet v-model="bottom_sheet" scrollable>
      <v-card>
        <v-card-title>
          <v-icon color="orange" class="mr-2">{{ getIcon(selectedItem) }}</v-icon> Expense Details
        </v-card-title>
        <v-card-text>
          <v-chip-group v-model="selectedItem.type">
            <v-chip v-for="t in types" :key="t.value" filter label class="mb-1" :value="t.value">{{ t.text }}</v-chip>
          </v-chip-group>

          <!-- categories-->
          <div v-if="selectedItem.type == 'expense'" style="margin-bottom: 5px">
            <v-chip-group v-model="selectedItem.cat" @change="onCategoryChange">
              <v-chip v-for="t in categories" :key="t.value" filter label class="mb-1" :value="t.value">{{
                t.text
              }}</v-chip>
            </v-chip-group>

            <v-chip-group v-model="selectedItem.subcat">
              <v-chip
                v-for="t in subcats(selectedItem.cat)"
                :key="t.value"
                filter
                label
                class="mb-1"
                :value="t.value"
                >{{ t.text }}</v-chip
              >
            </v-chip-group>
          </div>

          <v-text-field
            dense
            outlined
            type="text"
            inputmode="decimal"
            pattern="[0-9]*[.,]?[0-9]*"
            v-model="selectedItem.amount"
            :rules="[
              (v) => v === '' || v === null || /^[0-9]*([.,][0-9]{0,2})?$/.test(v) || 'Introduce un número válido',
            ]"
            label="amount"
            clearable
          >
            <template v-slot:append>
              <div style="display: flex; align-items: center">
                <span @click="cycleCurrency" style="cursor: pointer; user-select: none">
                  {{ selectedItem.currency }}
                </span>
              </div>
            </template>
          </v-text-field>
          <v-text-field dense outlined v-model="selectedItem.description" label="short text"></v-text-field>
          <v-textarea
            outlined
            v-model="selectedItem.comments"
            label="comments"
            auto-grow
            rows="1"
            clearable
          ></v-textarea>
          <v-checkbox dense v-model="selectedItem.curro" label="Curro"></v-checkbox>

          <FormDatePicker v-model="selectedItem.date" />
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="error" @click="deleteItem(selectedItem.id)">delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="success" @click="save">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!--add button-->
    <v-fab-transition>
      <v-btn fab bottom right fixed color="primary" @click="addNewItem" :loading="loading" style="margin-bottom: 56px">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import api from '@/assets/api'
import FormDatePicker from '@/components/FormDatePicker.vue'

export default {
  components: {
    FormDatePicker,
  },
  watch: {
    selectedIndex(n, o) {
      //this.bottom_sheet = true
      //this.selectedItem = { ...this.items[n] }
      //TODO: we could fetch instead, to make sure we see the latest thing
    },
  },

  data() {
    return {
      loading: false,
      bottom_sheet: false,
      selectedIndex: undefined,
      selectedItem: {},
      items: [],

      types: [
        { text: 'Gasto', value: 'expense' },
        { text: 'Ingreso', value: 'income' },
        { text: 'Yo Presto', value: 'lend' },
        { text: 'Me devuelven', value: 'lend-return' },
        { text: 'Me Prestan', value: 'borrow' },
        { text: 'Devuelvo', value: 'borrow-return' },
      ],
      categories: [
        {
          text: 'Transporte',
          value: 'transporte',
          icon: 'mdi-bus',
          subcategories: [
            { text: 'Taxi', value: 'taxi' },
            { text: 'Bus', value: 'bus' },
            { text: 'Tren', value: 'tren' },
          ],
        },

        {
          text: 'Supermercado',
          value: 'super',
          icon: 'mdi-cart-variant',
          subcategories: [
            { text: 'Básicos', value: 'basicos' },
            { text: 'Snacks', value: 'snacks' },
            { text: 'Mix', value: 'mix' },
          ],
        },
        {
          text: 'Restaurante',
          value: 'restaurante',
          icon: 'mdi-silverware-fork-knife',
          subcategories: [
            { text: 'Comida Curro', value: 'comida-curro' },
            { text: 'Cena', value: 'cena' },
            { text: 'Comida', value: 'comida' },
          ],
        },
        {
          text: 'Regalos',
          value: 'regalos',
          icon: 'mdi-gift',
          subcategories: [
            { text: 'Bodas', value: 'bodas' },
            { text: 'Rocío', value: 'rocio' },
            { text: 'Alex', value: 'alex' },
            { text: 'Elena', value: 'elena' },
            { text: 'Pablo', value: 'pablo' },
            { text: 'Otros', value: 'others' },
          ],
        },
        {
          text: 'Otros',
          value: 'other',
          icon: 'mdi-help',
          subcategories: [],
        },
      ],
    }
  },

  methods: {
    getIcon(item) {
      let icon = this.categories.find((x) => x.value == item.cat)?.icon || ''
      return icon
    },
    onItemClick(index) {
      this.selectedIndex = index
      this.selectedItem = { ...this.items[index] }
      this.bottom_sheet = true
    },
    onCategoryChange() {
      this.selectedItem.subcat = ''
      this.selectedItem = { ...this.selectedItem }
    },

    cycleCurrency() {
      const currencies = ['EUR', 'USD']
      const idx = currencies.indexOf(this.selectedItem.currency)
      this.selectedItem.currency = currencies[(idx + 1) % currencies.length]
    },

    subcats(cat) {
      return this.categories.find((x) => x.value == cat)?.subcategories || []
    },
    async deleteItem(id) {
      let conf = confirm('Are you sure?')
      if (!conf) return
      this.loading = true
      let x = await api.apiFetch(`/expenses/expenses?id=${id}`, {
        method: 'DELETE',
      })
      if (x.ok) {
        this.$emit('done', true)
      } else {
        alert('Something went wrong it seems')
      }
      this.fetchData()
      this.loading = false
      this.bottom_sheet = false
    },
    async save() {
      this.loading = true
      let x = await api.apiFetch('/expenses/expenses', {
        method: 'POST',
        body: JSON.stringify(this.selectedItem),
      })
      if (x.ok) {
        let j = await x.json()
        this.selectedItem = { ...j } //augmented JSON
        this.$emit('saved', true)
      }
      this.items[this.selectedIndex] = { ...this.selectedItem }
      this.bottom_sheet = false
      this.loading = false
    },
    todayYMD() {
      const d = new Date()
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    async addNewItem() {
      this.items.push({ text: '', date: this.todayYMD(), currency: 'EUR' })
      this.selectedIndex = this.items.length - 1
      this.bottom_sheet = true
    },
    async fetchData() {
      //TODO: Implement with API
      this.loading = true
      let x = await api.apiFetch('/expenses/expenses')
      if (x.ok) {
        this.items = await x.json()
      }
      this.loading = false
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
